import styled from "styled-components";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import { useState } from "react";
import { useModal } from "../../../contexts/ModalContext";
import useApi from "../../../hooks/useApi";
import { useParams } from "react-router-dom";

const WrapperBotoes = styled.div`
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
`
const BotaoSalvar = styled.button`
    background-color: #2563eb;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    &:hover {
        background-color: #1e40af;
    }
    transition: .2s all ease;
    margin: 15px 0 0 0px;
    padding: 10px 12px;
    box-sizing: border-box;
    &:disabled {
        background-color: #93c5fd;
        cursor: auto;
    }
`
const BotaoCancelar = styled.button`
    background-color: #e5e7eb;
    color: #333;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    &:hover {
        background-color: #d1d5db;
    }
    transition: .2s all ease;
    margin: 15px 10px 0 0;
    padding: 10px 12px;
    box-sizing: border-box;
`

const ModalNovoEmailNF = ({ fetchData }) => {

    const { closeModal } = useModal();
    const { id } = useParams();

    const [nomeUsuario, setNomeUsuario] = useState("");
    const [emailUsuario, setEmailUsuario] = useState("");

    const handleChangeEmail = (e) => {

        const valor = e.target.value;
        setEmailUsuario(valor.toLowerCase());

    }

    const [isEmailValido, setIsEmailValido] = useState(true);

    const verifyEmail = (email) => {

        const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        setIsEmailValido(regexEmail.test(email));

    }

    const api = useApi();

    const [ saving, setSaving ] = useState(false);

    const handleSubmit = async ( e ) => {

        e.preventDefault();

        if( !isEmailValido || nomeUsuario.trim() === "" || emailUsuario.trim() === "" ){

            alert("Por favor, preencha todos os campos corretamente.");
            return;

        }

        setSaving( true );

        try{

            const formData = new FormData();

            formData.append("nome", nomeUsuario);
            formData.append("email", emailUsuario);
            formData.append("id", id);

            const { data } = await api.post("/Painel/API/ControleMedicao/AddEmailNF/", formData);

            console.log(data);

            fetchData();
            closeModal();

        }catch( e ){

            console.log( e );

        }finally{

            setSaving( false );

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="sm" >
                    <Formulario onSubmit={ handleSubmit } >
                        <FormComp
                            title="PEDIDO DE COMPRA"
                            valor={`PC: ${id}`}
                            type="text"
                            readOnly
                        />
                        <FormComp
                            title="NOME"
                            valor={nomeUsuario}
                            type="text"
                            changeFunc={(e) => setNomeUsuario(e.target.value.toUpperCase())}
                        />
                        <FormComp
                            title="E-MAIL"
                            valor={emailUsuario}
                            type="text"
                            changeFunc={handleChangeEmail}
                            onBlur={() => verifyEmail(emailUsuario)}
                            invalid={!isEmailValido}
                        />
                        <WrapperBotoes>
                            <BotaoCancelar
                                type="button"
                                onClick={() => closeModal()}
                            >
                                CANCELAR
                            </BotaoCancelar>
                            <BotaoSalvar
                                disabled={ !isEmailValido || nomeUsuario.trim() === "" || emailUsuario.trim() === "" || saving }
                            >
                                SALVAR
                            </BotaoSalvar>
                        </WrapperBotoes>
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalNovoEmailNF;
